import { LogMessage } from './types';

const serializer = (messages: LogMessage[]) =>
  messages
    .map((m) => `${m.msg}:${m.context ? btoa(JSON.stringify(m.context)) : '__'}:${m.timestamp.getTime()}`)
    .join(',');

const deserializer = (s: string): LogMessage[] => {
  const messages = s.split(',');
  return messages.map((m) => {
    const [msg, context, timestamp] = m.split(':');
    return {
      msg,
      context: context === '__' ? undefined : JSON.parse(atob(context)),
      timestamp: new Date(Number(timestamp)),
    };
  });
};

export { deserializer, serializer };
